<template>
    <svg version="1.1" id="Lager_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 11.6999998 11.6999998" style="enable-background:new 0 0 11.6999998 11.6999998;"
         xml:space="preserve">
        <path class="st0" d="M5.8499999,2.2071059l0.4763274-0.4763275c1.1955786-1.1955786,3.1339941-1.1955786,4.3295727,0
	l0.0000048,0.0000043c1.1955786,1.1955787,1.1955786,3.1339946,0,4.3295732l-4.8055496,4.8055501H5.8496447L1.044095,6.0603557
	c-1.1955786-1.1955786-1.1955786-3.1339943,0-4.3295732l0.0000043-0.0000043c1.1955786-1.1955786,3.1339946-1.1955786,4.3295732,0
	L5.8499999,2.2071059z"/>
</svg>
</template>
<style scoped>
.st0 {
    fill: none;
    stroke: #000000;
    stroke-width: 0.25;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
}
</style>
